import { render, staticRenderFns } from "./StatisticByShops.vue?vue&type=template&id=559e5eab&scoped=true"
import script from "./StatisticByShops.vue?vue&type=script&lang=js"
export * from "./StatisticByShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e5eab",
  null
  
)

export default component.exports